import { defineStore } from 'pinia'
import axios from '@/utils/axios'

const TTL = 60 * 1000 // 1 minute

export const useFollowupStore = defineStore('followup', {
  state: () => ({
    list: [],
    lastFetch: 0,
    _loadingPromise: null,
  }),

  getters: {
    count: (state) => state.list.length,
  },

  actions: {
    async loadFollowups(force = false) {
      const now = Date.now()

      if (!force && this.lastFetch && (now - this.lastFetch) < TTL) {
        return this.list
      }

      if (this._loadingPromise) return this._loadingPromise

      this._loadingPromise = axios.get('/reminders/my/created')
        .then(res => {
          this.list = res.data.data || []
          this.lastFetch = Date.now()
          this._loadingPromise = null
          return this.list
        })
        .catch(err => {
          this._loadingPromise = null
          throw err
        })

      return this._loadingPromise
    },

    clearCache() {
      this.list = []
      this.lastFetch = 0
      this._loadingPromise = null
    },
  },

  persist: {
    pick: ['list', 'lastFetch'],
  },
})